module.exports = __webpack_public_path__ + "img/4_en.5f92db8e.webp";